// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FacebookDisabledPage-cls1___0f01483d8a1cc050b01{/*!*/}.FacebookDisabledPage-cls2___6c80184d8dc3404eb50{display:none;flex-direction:column}.FacebookDisabledPage-cls2___6c80184d8dc3404eb50.FacebookDisabledPage-show__c47cd81c5f4b427c5a54{display:flex}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "FacebookDisabledPage-cls1___0f01483d8a1cc050b01",
	"cls2": "FacebookDisabledPage-cls2___6c80184d8dc3404eb50 FacebookDisabledPage-cls1___0f01483d8a1cc050b01",
	"show": "FacebookDisabledPage-show__c47cd81c5f4b427c5a54"
};
export default ___CSS_LOADER_EXPORT___;
